import { Flex, Text } from "@jsq/ds/core";
import { detailLabel, detailValue } from "./styles_vanilla.css";

export const DetailsRow = ({ label, value }: { label: string; value: string }) => (
  <Flex gap={"20px"}>
    <Text variant="strong-md" className={detailLabel}>
      {label}
    </Text>
    <Text variant="regular-md" className={detailValue}>
      {value}
    </Text>
  </Flex>
);
